import React, {useEffect, useState} from 'react';
import { ColumnLayout, Container, ExpandableSection, Header, SpaceBetween, Spinner } from "@amzn/awsui-components-react-v3";
import { KeyValue } from 'src/components/commonComponents/KeyValue';
import {ALL_POD_NAMES, INFORMATION_HEADERS} from './ResilienceConstants';
import { convertCamelCaseToWords } from 'src/utils/StringUtils';
import {AWSResourceTabs} from "src/components/ResilienceWorkflow/AWSResources/AWSResourcesReview";
import {
    getResourceKey,
    SUPPORTED_AWS_RESOURCE_TYPES
} from "src/components/ResilienceWorkflow/AWSResources/ResourceTypeConstants";
import {getAwsResourceMetadata} from "src/utils/dynamoClientWrapper";
import {
    SourceToDestinationAccountTable
} from "src/components/ResilienceWorkflow/AWSResources/SourceToDestinationAccountTable";
import ShowSnowStatus from 'src/components/findEntity/ShowSNOWStatus';
import { UserIcon } from '../commonComponents/UserIcon';

export const ResilienceEntityData = ({ status, entityData, entityName}) => {
    const createdBy = entityData && entityData.CreatedBy;
    const awsDataMap: Object = entityData.EntityData['awsDataMap'];
    const resourceData = {};
    const loadingObject = {};
    if (awsDataMap) {
        Object.values(awsDataMap).map( sourceAccountMap => {
            if (sourceAccountMap.sourceAccountName !== 'Pipeline') {
                resourceData[sourceAccountMap.sourceAccountName] = {};
                loadingObject[sourceAccountMap.sourceAccountName] = true;
            }
        });
    }
    const [awsResources, setAwsResources] = useState(resourceData);
    const [loading, setLoading] = useState(loadingObject);
    useEffect(() => {
        async function fetchResources(awsResources) {
            let tempAwsResources = awsResources;
            let tempLoading = loading;
            for(let accountName of Object.keys(awsResources)) {
                const results: Array<Promise<any>> = [];
                const accountId = awsDataMap[accountName].sourceAccountId;
                for (const resourceType of SUPPORTED_AWS_RESOURCE_TYPES) {
                    results.push(getAwsResourceMetadata(`${accountId}#${getResourceKey(resourceType)}`))
                }
                const resources: Array<Array<any>> = await Promise.all(results);
                tempLoading = {
                    ...tempLoading,
                    [accountName]: false
                }
                setLoading(tempLoading)
                for (let i=0; i<8; i++) {
                    const resourceType = SUPPORTED_AWS_RESOURCE_TYPES[i];
                    const resource = resources[i]
                    tempAwsResources = {
                        ...tempAwsResources,
                        [accountName]: {
                            ...tempAwsResources[accountName],
                            [resourceType]: resource
                        }
                    }
                }
                setAwsResources(tempAwsResources);
            }
        }
        if (awsDataMap) {
            fetchResources(resourceData)
        }
    }, [])



    const getPhoneToolImageURL = (createdBy)  => {
        return "https://badgephotos.corp.amazon.com/?uid="+createdBy;
    }

    const getKeyVaueMap = (attribute) => {
        return (
            <KeyValue key={attribute[0]} label={convertCamelCaseToWords(attribute[0])}>{attribute[1]}</KeyValue>
        )
    }

    const getAWSAccountMapData = () => {
        let listOfAccounts: any = []
        const cell = entityData.EntityName.split('-')[1];
        const modifiedAwsDataMap = {
            [cell]: awsDataMap
        }

        if(entityData.Region) {
            let interimData = awsDataMap;
            let sourceAccounts = Object.keys(interimData);
            sourceAccounts.forEach( sourceAccount => {
                let sourceToDestinationMap: any = new Map()
                ALL_POD_NAMES[entityData.Region].map( cell => {
                    sourceToDestinationMap = {'sourceAccount': `${sourceAccount} | ${awsDataMap[sourceAccount].sourceAccountId}`}
                    if(modifiedAwsDataMap[cell][sourceAccount]) {
                        sourceToDestinationMap = {
                            ...sourceToDestinationMap,
                            [cell]: modifiedAwsDataMap[cell][sourceAccount].destinationAccountName
                        }
                    }
                })
                listOfAccounts.push(sourceToDestinationMap);
            })
        }

        return listOfAccounts;

    }

    const getInformationHeader = (attribute) => {
        return INFORMATION_HEADERS[attribute];
    }

    const getEntityAttributesContainer = (entityAttributes) => {
        if(entityAttributes) {
            const pipelineName = entityAttributes['pipelineData']['pipelineName'];
            return Object.keys(entityAttributes).map( attribute => {

                const informmationHeader = getInformationHeader(attribute);
                if(informmationHeader) {
                    return <ExpandableSection key={attribute} header={informmationHeader}>

                        {
                            informmationHeader === 'AWS Information' ?
                                (Object.keys(awsResources).length ?
                                    <div>
                                        <Container
                                            header={<Header variant="h2">Source AWS Details</Header>}
                                        >
                                            <ColumnLayout columns={2} variant="text-grid" borders="vertical">
                                                <SourceToDestinationAccountTable rows={getAWSAccountMapData()} region={entityData.Region} />
                                            </ColumnLayout>
                                        </Container>
                                        {Object.keys(awsResources).map( accountId => {
                                            return <Container key={accountId} header={<Header variant="h2">{accountId} Resources</Header>}>
                                                { loading?.[accountId] ? <Spinner size='big' /> : <AWSResourceTabs data={awsResources[accountId]} pipelineName={pipelineName} /> }
                                            </Container>
                                        })}
                                    </div>:
                                    <Container>No Resources Selected</Container>
                                ) :
                                <Container>
                                    <ColumnLayout columns={4} variant="text-grid" borders="vertical">
                                        {Object.entries(entityAttributes[attribute]).map(key => getKeyVaueMap(key))}
                                    </ColumnLayout>
                                </Container>
                        }
                    </ExpandableSection>
                }
            })
        }
    }
    
    return (
        <SpaceBetween size="l">
        <Container
          header={<Header variant="h2">ROSLIN Workflow - {entityName}</Header>}
          footer={getEntityAttributesContainer(entityData.EntityData)}
        >
          <ColumnLayout columns={4} variant="text-grid" borders="vertical">
            <KeyValue label="Created By">
               <UserIcon user={createdBy}/>
            </KeyValue>
            <KeyValue label="Entity">{entityData.EntityName}</KeyValue>
            <KeyValue label="Pipeline">{entityData.GroupId}</KeyValue>
            <KeyValue label="Status">
                <div className="awsui-util-status-positive">
                    {(status == null) ? <Spinner size={"normal"}/> : <ShowSnowStatus status={status}/>}
                </div>
            </KeyValue>
          </ColumnLayout>
        </Container>
      </SpaceBetween>      
    );
}

